import { LocalDate } from '@js-joda/core';
import { StoreType } from '@tock/shared/utils/connect';
import { TimeOption } from 'utils/timeUtils';
import { computeDisplayedTimes } from 'utils/offerings';
import { offeringsSelector } from './calendarSelectors';

export const displayedTimesSelector = (state: StoreType) => {
  return computeDisplayedTimes(
    state.app.config?.business,
    offeringsSelector(state),
    LocalDate.now().toString()
  ).map(({ value }: TimeOption) => value);
};
